<template>
    <common-modal width="huge" :heading="$t('pages.company.company_clients.add_client')" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <div v-if="prefillClient?.id" class="client-registration">
                <p>{{ $t('pages.company.company_clients.invitation_link') }}:</p>
                <span class="client-registration--link">{{ getClienRegistrationtUrl }}</span>
                <common-icon name="copy" size="huge" @click="copyUrl()"></common-icon>
            </div>
            <add-client-form :prefillClient="prefillClient" @client-added="emitEvent({ name: 'client-added' })"></add-client-form>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import AddClientForm from 'components/forms/company/AddClientForm'

    export default {
        components: {
            AddClientForm,
        },

        props: {
            prefillClient: { type: Object, default: undefined },
            company: { type: Object, default: undefined },
        },

        computed: {
            getClienRegistrationtUrl() {
                return `https://${this.hostURL}/#/fin-acc?tkn=${this.prefillClient.finalizeAccountToken}`
            },

            hostURL() {
                return `${this.company.subdomain}.${window.location.host}`
            },
        },

        methods: {
            copyUrl() {
                navigator.clipboard.writeText(this.getClienRegistrationtUrl)
                this.$toast.success(this.$t('common.microcopy.copied'))
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    .client-registration {
        &--link {
            color: $color-link;
        }

        .icon {
            cursor: pointer;
            margin-left: 10px;
        }
    }
</style>
